import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { WaldayuInfo } from '../../app/global'

/**
 * Generated class for the SongsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-songs',
  templateUrl: 'songs.html',
})
export class SongsPage {
  songs;
  all_songs;
  trad_songs;
  nurs_songs;
  song_filter = 'all';
  audio_playing = [];
  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.songs = WaldayuInfo.songs
    this.all_songs = WaldayuInfo.songs
    this.trad_songs = WaldayuInfo.songs.filter((song) => song.category[0] === "Traditional")
    this.nurs_songs = WaldayuInfo.songs.filter((song) => song.category[0] === "Nursery rhyme")
  }

  stopAllAudio() {
    this.audio_playing.forEach(element => {
      element.pause()
    });
    this.audio_playing = [];
  }

  playAudioTrack(track) {
    track.audio_file = track.audio[0] + ".mp3"
    track.audio_url = track.audio[0] + ".mp3"
    let path = "https://roedoejet.github.io/wmrc-ayajuthem/resources/audio/songs/" + track.audio_url
    let audio = new Audio(path)
    this.audio_playing.push(audio)
    audio.onended = () => this.audio_playing.pop();
    audio.play()
  }

  changeSongs(filter) {
    if (filter === 'trad') {
      this.songs = this.trad_songs
    } else if (filter === 'nurs') {
      this.songs = this.nurs_songs
    } else {
      this.songs = this.all_songs
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SongsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/songs/songs.ts